import React from 'react';

import PieChart from '../PieChart';
import { BLACK } from '../../style';

export default function DoughnutText({ value, max, min, color, text, label }) {
  return (
    <g>

      {!!label && <text className="smallText" transform="translate(0, 0)" textAnchor="middle">{label}</text>}
      <PieChart
        value={value}
        max={max}
        min={min}
        colors={[color, 'lightgrey']}
        innerRadius={18}
        outerRadius={28}
      />
      <text alignmentBaseline="middle" transform={`translate(36, 0)`} fill={BLACK}>
        {text}
      </text>
    </g>
  )
}


// WEBPACK FOOTER //
// ./src/components/DoughnutText/index.js